export default {
  community: null,
  loading: false,
  loaded: false
};
